define('model/search/lowBandwidthSearch',['../selector'], function(selector) {
    'use strict';
    return function(json) {
        return selector(json, 'r', 'a1, tp, cc, a2, nm, ph, ps, gh, ct, cst');
    };
});

